import React, { useEffect, useState } from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import RegisterBg from './RegisterBg'
import './RegisterBg.css';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import { auth } from '../firebase';
import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { base, rKey } from '../utils';
import RegLoading from './RegLoading';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PasswordIcon from '@mui/icons-material/Password';


function ForgotPassword() {
    const [email, setEmail] = useState('')
    const [width, setWidth] = useState(window.innerWidth);

    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)
    const [error, setError] = useState(false)


    useEffect(() => {
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
 
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);


    const resetPassword = async (e) => {
        e.preventDefault();

        if(email.trim() === '') {
            setError(true)
            setLoading(false)
            return
        }

        setError(false)
        setLoading(true)

        try {
          await sendPasswordResetEmail(auth, email);
          setSent(true);
          setLoading(false)
          setEmail('')
        } catch (error) {
          setError(true);
          setLoading(false)
        }
      };
    

    const styles = {
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'white', // Change border color
          },
          '&:hover fieldset': {
            borderColor: 'white', // Change border color on hover
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white', // Change border color when focused
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: 'white', // Change placeholder color
        },
        '& .MuiFormLabel-root': {
          color: 'white', // Change label text color
        },
        input: {color: 'white', width: '300px'}
      }


  return (
    <div className='reg_box' style={{width: '100vw', height: '100vh', display: 'flex', flexDirection: 'row'}}>
        <RegisterBg style={{zIndex: '1000000'}}/>

        {width > 768 && <Card>
            <h2>Reset Password</h2>
            
            {sent && <h4 className='done'>Password reset email sent! Please check your inbox</h4>}
            {error && <h4 className='error'>Failed to send password reset email. Please check the email address</h4>}

            {/* <TextField id="outlined-basic" label="Email" variant="outlined" sx={styles} type='email' onChange={e=> setEmail(e.target.value)}/>
            <TextField id="outlined-basic" label="Password" variant="outlined" sx={styles} type='password' onChange={e=> setPassword(e.target.value)}/> */}

            <div className='input_div'>
              <AlternateEmailIcon />
              <input type='email' onChange={e=> setEmail(e.target.value)} placeholder='email'/>
            </div>
            

            {!loading && <button onClick={e=> resetPassword(e)}>Submit</button>}
        
            {loading && <RegLoading />}
        </Card>}
    </div>
  )
}

export default ForgotPassword

const Card = styled.div`
    /* position: absolute;
    top: 50%;
    left: 50%; */
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    /* background-color: rgba(255, 255, 255, 0.10); */
    background-color: #19191976;
    filter: blur(95%);
    color: white;
    /* transform: translate(-50%, -50%); */
    gap: 25px;
    z-index: 1000;

    > .input_div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      background-color: #191919;
      border: 1px solid black;
      padding: 3px 6px;
      width: 290px;


      > input {
        font-family: 'Quicksand';
        padding: 4px;
        border: none;
        border-radius: 2px;
        outline: none;
        background-color: transparent;
        color: white;
        height: 25px;
        width: 100%;
      }

      > .MuiSvgIcon-root {
        color: white;
      }
    }

    > h2 {
        color: white;
        font-weight: 300;

        > span {
          font-family: 'Crimson Text';
          font-size: 37px;
        }
    }


    > button {
        background-color: white;
        color: black;
        border: 1px solid gray;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        margin-top: 25px;
        padding: 5px 10px;
        width: 300px;
        cursor: pointer;

        transition: background-color 0.3s ease-in-out;
    }

    > button:hover {
        background-color: black;
        color: white;
    }

    > p {
      color: white;
      font-size: 13px;
      margin-top: 20px;
    }

    > p > span {
      color: dodgerblue;
      cursor: pointer;
    }

    > p > span:hover {
      color: lightgray;
    }

    > .done {
      font-family: 'Quicksand';
      font-weight: 400;
      padding: 10px;
      background-color: var(--tst-color);
      color: green;
      border-radius: 3px;
      width: 60%;
    }

    > .error {
      font-family: 'Quicksand';
      font-weight: 400;
      padding: 10px;
      background-color: lightpink;
      color: crimson;
      border-radius: 3px;
      width: 60%;
    }
`